module.exports = __webpack_public_path__ + "static/Arauco_Implementación_VSTS-17fb6cd51a1a94101369a6eb5039771f.png";